/**
 * File-related constants
 */

/**
 * Allowed MIME types for file uploads
 * Organized by category for better maintainability
 */
export const ALLOWED_MIME_TYPES = [
  // Text files
  'text/plain',
  'text/csv', 
  'text/html',
  'text/xml',
  'text/css',
  'text/javascript',
  'text/markdown',
  
  // Data files
  'application/json',
  
  // Images
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/svg+xml',
  'image/webp',
  'image/avif',
  'image/heic',
  'image/heif',
  'image/heic-sequence',
  'image/heif-sequence',
  
  // Documents
  'application/pdf'
];

/**
 * Maximum file size in bytes (50MB)
 */
export const MAX_FILE_SIZE = 50 * 1024 * 1024; 